export default {
  columnsContainer: (theme) => ({
    columnGap: theme.spacing(1),
  }),
};
